const ThankYou = () => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#f3f4f6' }}>
            <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1.5rem', textAlign: 'center', color: '#167AC3' }}>
                Thank You for Trying Us!
            </h2>
            <p style={{ fontSize: '1.125rem', textAlign: 'center' }}>
                Thank you! We've received your details and are setting everything up for you.<br />
                Once your onboarding is complete, we'll notify you so you can log in and get started.
            </p>
        </div>
    );
};

export default ThankYou;
